module.exports = __webpack_public_path__ + "img/sec17mob.cdcd3e44.png";